import React, { memo } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  ResponsiveContainer,
  Tooltip,
  YAxis,
} from "recharts";
import DATA from "../../assets/data";
import { keyValueConstructor,valueConverter  } from "../../util-functions/util-funtions";
// function dataConstruct(data) {
//   let new_data = data.map((itm, ind) => {
//     return { name: itm.ChannelName, value: itm.SecondarySale + ind * 15 };
//   });
//   return new_data;
// }

const CustomizedLabel = (props) => {
  const { x, y, stroke, value } = props;

  // return <text x={x-2} y={y} dy={-4} fill={stroke} fontSize={10} textAnchor="start" verticalAnchor='start'>{Number.parseInt(value).toLocaleString()}</text>
  return <text x={x-2} y={y} dy={-4} fill={stroke} fontSize={10} textAnchor="start" verticalAnchor='start'>{valueConverter(value)}</text>


}

const GeoChannel = memo((props) => {
  let result_data = keyValueConstructor(props.data);
  // let result_data = [];
  // console.log(result_data)
  CustomizedAxisTick.defaultProps = {
    width: 60,
    maxChars: 11,
    fontSize: 12,
    lineHeight: 15,
    fill: "#333",
  };
  function CustomizedAxisTick(props, data) {
    const {
      x,
      y,
      payload,
      width,
      maxChars,
      lineHeight,
      fontSize,
      fill,
    } = props;

    const rx = new RegExp(`.{1,${maxChars}}`, "g");
    const chunks = payload.value
      .replace(/-/g, " ")
      .split(" ")
      .map((s) => s.match(rx))
      .flat();
    const tspans = chunks.map((s, i) => (
      <tspan x={0} y={lineHeight} dy={i * lineHeight}>
        {s}
      </tspan>
    ));
    return (
      <g transform={`translate(${x},${y})`}>
        <text
          width={width}
          height="auto"
          textAnchor="middle"
          fontSize={fontSize}
          fill={fill}
        >
          {tspans}
        </text>
      </g>
    );
  }

  function renderTooltip(e, data) {
    return data.map((itm, ind) => {
      return (
        itm.name === e.label && (
          <div
            style={{
              height: "50px",
              width: "auto",
              padding: "10px",
              backgroundColor: "white",
            }}
          >
            <span style={{ color: DATA.COLOR[ind] }}>
              {itm.name}
              <br />
              {/* Value: {Number.parseInt(itm[`${Object.keys(itm)[0]}`][`${e.label}`]).toLocaleString()} */}
              {itm.value.toLocaleString()}
            </span>
          </div>
        )
      );
    });
  }
  return (
    <ResponsiveContainer height="100%" width="100%">
      <BarChart
        width={200}
        height={300}
        // data={result_data.length > 0 ? result_data : DATA.GEOCHANNEL}
        data={result_data}
        margin={{
          top: 5,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        {/* <CartesianGrid strokeDasharray="3 3" /> */}
        <YAxis tickLine={false} style={{ fontSize: "12px" }} tickFormatter={tick => { return valueConverter(tick) }} padding={{ top: 25 }}/>
        <XAxis
          dataKey="name"
          tick={<CustomizedAxisTick />}
          interval={0}
          height={70}
        />
        <Tooltip content={(e) => renderTooltip(e, result_data)} />
        <Bar
          dataKey="value"
          fill="#4d79a8"
          label={<CustomizedLabel myProps={result_data?result_data:[]} />}
          // radius={[5, 5, 0, 0]}
          width={20}
          barSize={25}
        ></Bar>
      </BarChart>
    </ResponsiveContainer>
  );
});

export default GeoChannel;
